import { UniqueProductLabelId } from "@/enums/UniqueProductLabelId"
import { MenuType } from "@reef-os/utils/enums/menuType"
import utils from "@/utils"

let menuCategoriesMixin = {
    data: function() {
        return  {
			scrollingToCategory: false,
            categoriesScrollToOffset: 120
        }
    },
    computed: {
		categorizedMenuRefKey() {
			return null
		},
		categorizedMenu() {
			if (!this.$store.getters.menusHash) {
				return []
			}

			const menu = {
				"-1": {
					menuId: 0,
					items: {
						"-1": []
					},
					categoryOrder: [-1],
					expanded: true
				}
			}
			this.menu.forEach((item) => {
				if (item.labels) {
					const hasPreorderOnlyLabel = item.labels.some(
						(label) =>
							label.id == UniqueProductLabelId.PREORDER_ONLY
					)
					const isPopup = item.menu_type == MenuType.POPUP
					if (hasPreorderOnlyLabel && isPopup) {
						return
					}
				}

				if (!menu[item.menu_id]) {
					menu[item.menu_id] = {
						menuId: item.menu_id,
						categoryOrder:
							this.$store.getters.menusHash[item.menu_id]
								.categoryOrder,
						items: {}
					}
				}

				if (item.category_id && item.category_id != -1) {
					if (
						menu[item.menu_id].items[item.category_id] == undefined
					) {
						menu[item.menu_id].items[item.category_id] = []
					}
					menu[item.menu_id].items[item.category_id].push(item)
				} else {
					menu["-1"].items["-1"].push(item)
				}
			})
			return Object.values(menu)
				.map((menu) => {
					const categories = Object.entries(menu.items)
						.map((category) => {
							const categoryName =
								this.$store.state.categories &&
								this.$store.state.categories[category[0]]
									? this.$store.state.categories[category[0]]
									: "N/A"
							return {
								categoryId: category[0],
								categoryName: categoryName,
								items: category[1]
							}
						})
						.sort(
							(a, b) =>
								menu.categoryOrder.indexOf(
									Number(a.categoryId)
								) -
								menu.categoryOrder.indexOf(Number(b.categoryId))
						)
					return {
						categories: categories,
						menuId: menu.menuId
					}
				})
				.sort((a, b) => a.menuId - b.menuId)
		}
    },
    methods: {
        scrollToSelectedCategory(category) {
			const menuRef = this.categorizedMenuRefKey && this.$refs[this.categorizedMenuRefKey] ? this.$refs[this.categorizedMenuRefKey] : this
			const categoryTitle = menuRef ? menuRef.$refs[`category-${category.id}`] : null
			const menuPage = this.$refs.menuPage
			if (menuPage && categoryTitle && categoryTitle[0] && menuPage) {
				const top = categoryTitle[0].offsetTop
				const offset = this.categoriesScrollToOffset
				menuPage.scrollTo({
					top: top + window.pageYOffset + offset,
					behavior: "smooth"
				})
			}
			this.scrollingToCategory = true
			setTimeout(() => {
				this.scrollingToCategory = false
			}, 1200)
		},
        calculateCategoryWhenScrolling(navbarRef, categorySectionRef) {
            if (!this.scrollingToCategory && categorySectionRef && navbarRef) {
				const visibleSection = categorySectionRef.find(
					(el) => {
						return utils.isVisible(el, 110)
					}
				)
				const visibleSectionId = visibleSection ? visibleSection.id.replace("category-section-", "") : null
				navbarRef.setCategoryId(visibleSectionId)
			}
        }
    }
}

export default menuCategoriesMixin